;(function () {
  'use strict'

  angular
    .module('admin.deposit_match.service', [])
    .factory('DepositMatchService', DepositMatchService)

  /** @ngInject */
  function DepositMatchService($http, $q, API) {
    function list() {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/deposit_match_events')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listOfferSegmentation(id) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/deposit_match_events/' + id + '/user_segments')
        .success(defered.resolve)

      return defered.promise
    }

    function addOfferSegmentation(id, segmentId) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'admin/deposit_match_events/' + id + '/user_segments/' + segmentId)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function removeOfferSegmentation(id, segmentId) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'admin/deposit_match_events/' + id + '/user_segments/' + segmentId)
        .success(defered.resolve)

      return defered.promise
    }

    function get(id) {
      var defered = $q.defer()

      $http.get(API.API_URL + 'admin/deposit_match_events/' + id).success(defered.resolve)

      return defered.promise
    }

    function create(model) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'admin/deposit_match_events', model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function update(id, model) {
      var defered = $q.defer()

      $http
        .put(API.API_URL + 'admin/deposit_match_events/' + id, model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function remove(id) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'admin/deposit_match_events/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    return {
      list: list,
      get: get,
      create: create,
      update: update,
      remove: remove,
      listOfferSegmentation,
      addOfferSegmentation,
      removeOfferSegmentation,
    }
  }
})()
